"use client";

import { ArrowRight, Square } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheCurrentEdit() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const expertise = [{
    label: "SOURCING",
    value: "ETHICAL"
  }, {
    label: "CONSTRUCTION",
    value: "BESPOKE"
  }, {
    label: "PATTERN",
    value: "PRECISION"
  }, {
    label: "DESIGNER",
    value: "ALEX THORNE"
  }, {
    label: "COLLECTION",
    value: "VOID_04"
  }, {
    label: "INSPIRATION",
    value: "BRUTALIST"
  }];
  return <section data-section-id="2164" id="the-current-edit" ref={sectionRef} className="dark bg-[#1a1614] text-[#fcfaf7] relative w-full min-h-[900px] flex flex-col justify-center overflow-hidden py-32 md:py-48">
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700152/img/studio_thorne_runway_texture.webp)] opacity-40" aria-hidden="true" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#1a1614] via-[#1a1614]/80 to-transparent" aria-hidden="true" />
      
      <div className="absolute right-0 top-1/2 -translate-y-1/2 w-1/2 h-full opacity-5 pointer-events-none" aria-hidden="true">
      </div>

      <div className="absolute right-6 top-1/2 -translate-y-1/2 hidden lg:block">
      </div>

      <div className="absolute top-12 right-12 grid grid-cols-4 gap-2 opacity-20 hidden md:grid">
        {Array.from({
        length: 16
      }).map((_, i) => <div key={i} className="size-1 bg-[#fcfaf7] rounded-lg" />)}
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          
          <div className="lg:col-span-9 space-y-12">
            <div className="space-y-4 transition-all duration-1000 ease-out" style={{
            opacity: sectionVisible ? 1 : 0,
            transform: sectionVisible ? "translateY(0)" : "translateY(30px)"
          }}>
              <div className="flex items-center gap-4">
                <div className="h-px w-12 bg-[#3eb0c2]" />
                <span className="font-mono text-xs uppercase tracking-[0.2em] text-[#3eb0c2]">
                  EST. 2024 — LUXURY ATELIER
                </span>
              </div>

              <h1 className="font-serif font-light leading-[0.9] tracking-tighter text-[#fcfaf7] max-w-4xl" style={{
              fontSize: "clamp(3.5rem, 10vw, 7.5rem)"
            }}>
                STUDIO <br />
                <span className="relative inline-block">
                  THORNE
                </span>
              </h1>
            </div>

            <div className="max-w-xl space-y-8 transition-all duration-1000 delay-200 ease-out" style={{
            opacity: sectionVisible ? 1 : 0,
            transform: sectionVisible ? "translateY(0)" : "translateY(30px)"
          }}>
              <p className="font-sans text-lg md:text-xl text-[#fcfaf7]/80 leading-relaxed">
                Clinical precision meets visceral streetwear. Engineering the future of textile architecture through a lens of technical couture and archival research.
              </p>

              <div className="flex flex-wrap gap-4">
                <Button asChild size="lg" className="bg-[#fcfaf7] text-[#1a1614] hover:bg-[#3eb0c2] hover:text-[#fcfaf7] rounded-lg px-10 py-8 text-sm font-medium uppercase tracking-widest transition-colors duration-300 shadow-md">
                  <Link to="/CollectionsPage">
                    Download Line Sheet
                    <ArrowRight className="ml-2 size-4" />
                  </Link>
                </Button>

                <Button asChild variant="outline" size="lg" className="border-[#fcfaf7]/20 bg-transparent text-[#fcfaf7] hover:border-[#3eb0c2] hover:text-[#3eb0c2] rounded-lg px-10 py-8 text-sm font-medium uppercase tracking-widest transition-colors duration-300 shadow-md">
                  <Link to="/AtelierPage">Explore Atelier</Link>
                </Button>
              </div>
            </div>
          </div>

          <div className="lg:col-span-3 space-y-8 transition-all duration-1000 delay-400 ease-out" style={{
          opacity: sectionVisible ? 1 : 0,
          transform: sectionVisible ? "translateY(0)" : "translateY(30px)"
        }}>
            <div className="bg-[#fcfaf7]/5 backdrop-blur-sm border border-[#fcfaf7]/10 p-8 rounded-lg shadow-lg">
              <div className="flex items-center justify-between mb-8 pb-4 border-b border-[#fcfaf7]/10">
                <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#fcfaf7]/50">
                  Designer_Info
                </span>
                <div className="flex items-center gap-2">
                  <div className="size-1.5 bg-[#3eb0c2] rounded-lg animate-pulse" />
                  <span className="font-mono text-[10px] uppercase tracking-widest text-[#3eb0c2]">Active</span>
                </div>
              </div>

              <div className="space-y-6">
                {expertise.map((item, i) => <div data-index={i} key={item.label} className="group">
                    <div className="flex justify-between items-end mb-1">
                      <span className="font-mono text-[10px] uppercase tracking-widest text-[#fcfaf7]/40 group-hover:text-[#3eb0c2] transition-colors">
                        {item.label}
                      </span>
                      <span className="font-sans font-medium text-sm text-[#fcfaf7]">
                        {item.value}
                      </span>
                    </div>
                    <div className="h-px w-full bg-[#fcfaf7]/10 group-hover:bg-[#3eb0c2]/30 transition-colors" />
                  </div>)}
              </div>

              
            </div>
          </div>

        </div>
      </div>
    </section>;
}